import { autoinject } from 'aurelia-framework';
import { FileLoader } from 'services/file-loader';

import './gallery.scss';

@autoinject
export class Gallery {
  public images = [];


  constructor(
    private fileLoader: FileLoader
  ) {
    for (let index = 0; index < 35; index++) {
      this.images.push(this.fileLoader.getFile('img' + (index + 1)));
    }
  }
}